import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isRegistered: false,        //通道注册状态
        iscalling: false,           //是否通话中
        isincall: false,            //是否呼入

        //案件详情分页ID
        caseinfoPageId: {},
        //Tags
        visitedViews: [],
        menu: [],

        //微信公众号
        proData: [
            {value: 'wodeshanganyun', label: '我的上岸云', crypto: 'QYAch0lQhfIsAC%2Bto4C4j%2F05ZIVxOpDVCQvabpAsz6w%3D'},
            {value: 'zhailifang', label: '债立方', crypto: '5I0d30dgv%2BnqoJYGYV4Cyg%3D%3D'},
            {value: 'zhaijinli', label: '债锦鲤', crypto: 'TVS76vn0TtN6IwMw9%2BxKlw%3D%3D'},
            {value: 'wodezhaiguanjia', label: '我的债管家', crypto: 'Q94ClIvkVG4DDtg2GWnfrW6jLOXik9cLIOWNsoYl8U0%3D'},
            {value: 'wodeshangantong', label: '我的上岸通', crypto: 'D8R%2FddWS6ZItmTINmDQX8qKulGKwm7RtR%2BM4R27XiMc%3D'},
            {value: 'zhaiweilai', label: '债未来', crypto: 'qhIQGs6OLrhdjuWdVkO5OQ%3D%3D'},
            {value: 'wodewuyouguanjia', label: '我的无忧云管家', crypto: '9DRO9worazl1lpjCJJH7vugPDgz1na%2FVoxAq%2FPgz8Yo%3D'},
        ],
    },
    mutations: {
        //通道注册状态
        SET_IS_REGISTERED: (state,isRegistered) => {
            state.isRegistered = isRegistered
        },
        //是否通话中
        SET_IS_CALLING: (state,iscalling) => {
            state.iscalling = iscalling
        },
        //是否呼入
        SET_IS_IN_CALL: (state,isincall) => {
            state.isincall = isincall
        },
        //案件详情页
        SET_CASEINFO_PAGE_ID: (state, caseinfoPageId) => {
            state.caseinfoPageId = caseinfoPageId
        },
        //Tags
        ADD_VISITED_VIEW: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) return
            state.visitedViews.push(view)
        },
        
        DEL_VISITED_VIEW: (state, view) => {
            for (const [i, v] of state.visitedViews.entries()) {
              if (v.path === view.path) {
                state.visitedViews.splice(i, 1)
                break
              }
            }
        },
        
        UPDATE_VISITED_VIEW: (state, view) => {
            for (let v of state.visitedViews) {
              if (v.path === view.path) {
                v = Object.assign(v, view)
                break
              }
            }
        },
        
        SET_CASEINFO_PAGE_ID: (state, caseinfoPageId) => {
            state.caseinfoPageId = caseinfoPageId
        },
        
        SET_MENU: (state, menu) => {
            state.menu = menu
        },
    },
    actions: {
        addCaseinfoId({ state, commit }, info) {
            // Object.assign(state.caseinfoPageId, info)
            commit('SET_CASEINFO_PAGE_ID', {...state.caseinfoPageId, ...info})
        },
        
        delCaseinfoId({ state, commit }, id) {
            delete state.caseinfoPageId[id]
            commit('SET_CASEINFO_PAGE_ID', state.caseinfoPageId)
        },

        addView({ dispatch }, view) {
            dispatch('addVisitedView', view)
        },

        addVisitedView({ commit }, view) {
            commit('ADD_VISITED_VIEW', view)
        },

        delView({ dispatch, state }, view) {
            return new Promise(resolve => {
              dispatch('delVisitedView', view)
              resolve({
                visitedViews: [...state.visitedViews],
              })
            })
        },

        delVisitedView({ commit, state }, view) {
            return new Promise(resolve => {
              commit('DEL_VISITED_VIEW', view)
              resolve([...state.visitedViews])
            })
        },

        updateVisitedView({ commit }, view) {
            commit('UPDATE_VISITED_VIEW', view)
        },
        
        addCaseinfoId({ state, commit }, info) {
            // Object.assign(state.caseinfoPageId, info)
            commit('SET_CASEINFO_PAGE_ID', {...state.caseinfoPageId, ...info})
        },
        
        delCaseinfoId({ state, commit }, id) {
            delete state.caseinfoPageId[id]
            commit('SET_CASEINFO_PAGE_ID', state.caseinfoPageId)
        }
    },
    
    modules: {
        
    },
})


// WEBPACK FOOTER //
// ./src/store/index.js